import React from "react";

import ContractSummaryInfoItem from "./ContractSummaryInfoItem.jsx";
import ContractSummaryInfoHeader from "./ContractSummaryInfoHeader.jsx";

/**
 * @typedef {import("../../../jsdoc/GroupCount.js").GroupCount} GroupCount
 */

/**
 * ContractSummaryInfo Component
 * @param {Object} props
 * @param {GroupCount[]} props.groupCounts
 * @returns {React.JSX.Element}
 */
export default function ContractSummaryInfo({ groupCounts }) {
  return (
    <table
      id="Summary"
      role="grid"
      className="table table-bordered"
      summary="Counts of contract holders and contracts by group"
    >
      <ContractSummaryInfoHeader />
      <tbody role="rowgroup">
        {groupCounts.map(({ category, group, groupClass, contractHolderCount, contractCount }) => (
          <ContractSummaryInfoItem
            key={`${category}${group}${groupClass}`}
            category={category}
            group={group}
            groupClass={groupClass}
            contractHolderCount={contractHolderCount}
            contractCount={contractCount}
          />
        ))}
      </tbody>
    </table>
  );
}
